import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { STORAGE_KEYS } from '../constants/storage.constants';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  let token: string | null = null;
  let tempToken: string | null = null;

  try {
    token = sessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
    tempToken = sessionStorage.getItem(STORAGE_KEYS.TEMP_SIGNUP_TOKEN);
  } catch {
    // Storage access might fail in restricted environments
  }

  let headers = req.headers;

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  } else if (tempToken) {
    headers = headers.set('X-Session-Token', tempToken);
  }

  const clonedReq = req.clone({ headers });

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        try {
          sessionStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
          sessionStorage.removeItem(STORAGE_KEYS.CURRENT_USER);
        } catch {
          // Ignore
        }
        router.navigate(['/auth/login'], {
          queryParams: { sessionExpired: 'true' },
        });
      }
      return throwError(() => error);
    })
  );
};
